module.exports = __webpack_public_path__ + "static/slack-b2af59c3b14ac81189cf18e6cdf1045d.jpg";